/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import React from 'react'
import { font, paragraphSmall } from 'src/components/css'
import {
  detailSectionPanelStyle,
  detailSectionStyle,
  detailSectionTitleStyle,
} from './detailSectionStyles'

export interface PlayerBioSectionProps {
  bio?: string | null
}

/** Free-text bio from the candidate listing. Renders nothing when unset. */
const PlayerBioSection: React.FC<PlayerBioSectionProps> = ({ bio }) => {
  if (!bio) {
    return null
  }
  return (
    <div css={detailSectionStyle}>
      <span css={detailSectionTitleStyle}>{capitalizeWords('Player Bio')}</span>
      <p css={[detailSectionPanelStyle, bodyStyle]}>{bio}</p>
    </div>
  )
}

export default PlayerBioSection

const bodyStyle = css`
  ${font.body}
  ${paragraphSmall}
  margin: 0;
  padding: 12px;
  color: ${colors.WHITE};
`
